import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { DataTransferService } from 'src/app/service/data-transfer.service';
import 'rxjs/add/operator/first';


@Injectable()
export class FormGuard implements CanActivate {

    constructor(
        private router: Router,
        private dataTransfer: DataTransferService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const result = this.dataTransfer.currentValue.map(value => {
            if (value.length === 0) {
                return false;
            } else {
                return true;
            }
        });
        if (!result) {
            this.router.navigate(['login-externo']);
        }
        return result
    }
}
